import { Button } from '@lego/connect-components-react';
import { Component, type ReactNode } from 'react';

type Props = { children: ReactNode };
type State = { error: Error | null };

/**
 * Top-level error boundary so a crash in any page does not blank the entire app.
 * Shows a minimal recovery UI.
 */
export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  private handleReload = () => {
    window.location.reload();
  };

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div className="flex flex-col items-center justify-center min-h-dvh p-400 text-center bg-core-slate-50">
        <h1 className="text-heading-2xl mb-200">Something went wrong</h1>
        <p className="text-body-md mb-100 max-w-[600px] break-words">
          The application hit an unexpected error.
        </p>
        <p className="text-body-sm mb-300 text-core-slate-1100">
          Please reload the page. If this keeps happening, contact the Labeling Platform team.
        </p>
        <Button variant="primary" onClick={this.handleReload}>
          Reload
        </Button>
      </div>
    );
  }
}
